import * as React from "react";
import admin2Gql from "graphql-tag";
import { Query, useQuery } from "react-apollo";
import Select from "react-select";
import { useAdmin2Client } from "../App/ClientProvider";
import { SelectIdpsList } from "../admin-gql-2";

export const SelectIdps = (props: {
  selectedIdps: string[];
  onChange: (selectedIdps: string[]) => void;
  fetchCurrentSelectedIdps?: () => Promise<string[]>;
  disabled?: boolean;
}) => {
  const client = useAdmin2Client();
  const idps = useQuery<SelectIdpsList>(
    admin2Gql`query SelectIdpsList {
      idpList(hideOnUi: false) {
        nodes {
          id
          name
        }
      }
  }`,
    {
      client,
      fetchPolicy: "cache-and-network",
    }
  );

  const idpOptions =
    idps.data && !idps.loading && idps.data.idpList && idps.data.idpList.nodes
      ? idps.data.idpList.nodes.map(x => ({ label: x.name, value: x.id }))
      : [];

  const preservedHiddenIds = props.selectedIdps.filter(x => !idpOptions.some(y => y.value === x));

  const value = props.selectedIdps.map(x => idpOptions.find(y => y.value === x)).filter(Boolean) as Array<{ label: string; value: string }>;

  return (
    <Select
      options={idpOptions}
      isLoading={idps.loading}
      isMulti
      isDisabled={props.disabled}
      value={value}
      onChange={(options: any) => {
          const selectedValues = (options || []).map((x: any) => x.value);
          if (props.fetchCurrentSelectedIdps) {
            props.fetchCurrentSelectedIdps()
              .then((currentIds) => {
                const freshHiddenIds = currentIds.filter(x => !idpOptions.some(y => y.value === x));
                props.onChange([...freshHiddenIds, ...selectedValues]);
              })
              .catch(() => {
                props.onChange([...preservedHiddenIds, ...selectedValues]);
              });
          } else {
            props.onChange([...preservedHiddenIds, ...selectedValues]);
          }
        }}
    />
  );
};
